import React from 'react';
import { Link } from 'react-router-dom';
import fullLogo from '../../images/techtop-full-logo.svg';


class Footer extends React.Component {
  render() {
    return (
      <footer className="techtop-footer-div py-4">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
				<img src={fullLogo} className="img-fluid d-block" alt="Techtop"/>
				<p className="m-0"><strong>Motors & Relationships Built to Last</strong></p>
				<p className="m-0">Quality is the main ingredient</p>
            </div>
			<div className="col-md-4">
				<div>
					<h3 className="color1 fw-bold w-fit-content">Quick Links</h3>
					<a className="link-with-icon text-dark fw-normal d-flex align-items-center gap-2" href="/"><i className="fas fa-home"></i> Home</a>
					<a className="link-with-icon text-dark fw-normal d-flex align-items-center gap-2" href="/products/empty"><i className="fas fa-search"></i> Search Products</a>
					<a className="link-with-icon text-dark fw-normal d-flex align-items-center gap-2" href="/contact"><i className="fas fa-address-book"></i> Contact Us</a>
					<a className="link-with-icon text-dark fw-normal d-flex align-items-center gap-2" href="/track-shipment"><i className="fas fa-truck"></i> Track your Shipment</a>
					<a className="link-with-icon text-dark fw-normal d-flex align-items-center gap-2" href="/downloads"><i className="fas fa-download"></i> Downloads</a>
				</div>
            </div>
			<div className="col-md-4">
				<div>
					<h3 className="color1 fw-bold w-fit-content">Contact Us</h3>
					<a className="link-with-icon text-dark fw-normal d-flex align-items-center gap-1" href="/support"><i className="fas fa-at"></i> Contact Support</a>
					<a className="link-with-icon text-dark fw-normal d-flex align-items-center gap-1" href="/quality-control"><i className="fas fa-tools"></i> Quality Control</a>
					<a href="tel:6784365540" className="link-with-icon text-dark fw-normal d-flex align-items-center gap-2"><i className="fas fa-phone"></i> Tel. 678-436-5540</a>
					<a href="mailto:orders@techtopind.com" className="link-with-icon text-dark fw-normal d-flex align-items-center gap-2"><i className="fas fa-envelope"></i> orders@techtopind.com</a>
					<span className="text-dark fw-normal d-flex align-items-center gap-2"><i className="fas fa-building"></i> 2815 Colonnades Ct, Peachtree Corners, GA 30071</span>
				</div>
			</div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
